'use client';

import { useTranslations } from 'next-intl';
import { Filter } from '@terra/ui-design-system';
import {
  HTTP_METHOD_VERBS,
  normalizeMethodsFilter,
  type HttpMethodVerb,
} from '../../../store/tab/assetsTabScopedFilterStore';

const METHOD_FILTER_ITEMS = HTTP_METHOD_VERBS.map((method) => ({
  value: method,
  label: method,
}));

export function AssetsMethodFilter({
  value,
  onValueChange,
  disabled,
}: {
  value: HttpMethodVerb[];
  onValueChange: (methods: HttpMethodVerb[]) => void;
  disabled: boolean;
}) {
  const t = useTranslations('proxy.assets.table');

  return (
    <Filter
      id="method"
      density="compact"
      placeholder={t('method')}
      items={METHOD_FILTER_ITEMS}
      value={value}
      isMultiSelect
      onChange={(methods) => onValueChange(normalizeMethodsFilter(methods))}
      disabled={disabled}
    />
  );
}
